<route>
{
    "name": "index",
    "meta": {
        "permission": "guest",
        "fail": "/404"
    }
}
</route>
<template>
  <home-layout :class="[contentClass]">
  </home-layout>
</template>

<script>
import HomeLayout from "Layouts/Home.vue";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("auth");

export default {
    components: {
        HomeLayout
    },
    data: () => ({
        contentClass: { white: true, "accent--text": true }
    }),

    computed: {
        ...mapState({
            isAuthenticated: "isAuthenticated"
        })
    },
    mounted() {
        let self = this
        if (self.isAuthenticated) {
          return self.$nextTick(() => self.$router.push({name: 'dashboard'}));
        } else {
          window.location.assign("/auth/oidc/start");
        }
    }
};
</script>
<style scoped>
.image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 2px solid #ba9a5a;
  margin: 15px;
}
</style>
